module.exports = __webpack_public_path__ + "static/media/2023-Sub-Exclusive-Feature-Banner-lg@2x.51432cb4.webp";